module.exports = __webpack_public_path__ + "img/footer-icon.78b9385.webp";